import { ChangeEvent } from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { DrawerFilterReport } from "src/Pages/components/DrawerFilterReport/DrawerFilterReport";

import { IReportContractsToInstallmentsFilters } from "../../types";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";

interface IDrawerFilterContractsToInstallmentsProps {
  filters: IReportContractsToInstallmentsFilters;
  loading: boolean;
  onChange: (filters: IReportContractsToInstallmentsFilters) => void;
  onClear: () => void;
  onSubmit: () => Promise<void> | void;
}

export const DrawerFilterContractsToInstallments = ({
  filters,
  loading,
  onChange,
  onClear,
  onSubmit,
}: IDrawerFilterContractsToInstallmentsProps) => {
  const handleChange =
    (prop: keyof IReportContractsToInstallmentsFilters) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      const nextValue =
        prop === "cpf_cnpj"
          ? apenasNumeros(event.target.value)
          : event.target.value;

      onChange({
        ...filters,
        [prop]: nextValue,
      });
    };

  return (
    <DrawerFilterReport onClear={onClear} onApply={onSubmit}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          "& .MuiAutocomplete-root": { margin: 0 },
        }}
      >
        <Box>
          <DividerCore title="Período" sxStyle={{ margin: "0 0 16px 0" }} />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data inicial *"
                type="date"
                variant="outlined"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={filters?.start_date}
                onChange={handleChange("start_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data final *"
                type="date"
                variant="outlined"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={filters?.end_date}
                onChange={handleChange("end_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                select
                label="Tipo de data *"
                variant="outlined"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={filters?.type_date}
                onChange={handleChange("type_date")}
              >
                <MenuItem value="ASSINATURA">Assinatura</MenuItem>
                <MenuItem value="VIGENCIA">Vigência</MenuItem>
                <MenuItem value="EMISSAO">Emissão</MenuItem>
              </AppTextField>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <DividerCore title="Clientes" sxStyle={{ margin: "0 0 16px 0" }} />
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <AppTextField
                  fullWidth
                  label="Código da proposta"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  variant="outlined"
                  value={filters?.cod_proposta}
                  onChange={handleChange("cod_proposta")}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <AppTextField
                  fullWidth
                  label="Nome do cliente"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  variant="outlined"
                  value={filters?.nome}
                  onChange={handleChange("nome")}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <AppTextField
                  fullWidth
                  label="CPF/CNPJ"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  variant="outlined"
                  value={filters?.cpf_cnpj}
                  onChange={handleChange("cpf_cnpj")}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </DrawerFilterReport>
  );
};
